// extracted by mini-css-extract-plugin
export var aboveInput = "_nb-0";
export var actionButton = "_nb-5";
export var actionButtonContainer = "_nb-1";
export var actionIcon = "_nb-6";
export var aiInfoContainer = "_nb-2";
export var attachmentWrapper = "_nb-7";
export var bold = "_nb-3";
export var checkIcon = "_nb-8";
export var clickingRecipientBar = "_nb-11";
export var commentThreadSwitch = "_nb-a";
export var draftImage = "_nb-b";
export var draftImageContainer = "_nb-c";
export var draftImages = "_nb-e";
export var editButton = "_nb-g";
export var editor = "_nb-f";
export var editorContainer = "_nb-y";
export var editorErrorTooltipWrapper = "_nb-9";
export var headerDivider = "_nb-h";
export var icon = "_nb-i";
export var info = "_nb-j";
export var internal = "_nb-n";
export var internalDivider = "_nb-k";
export var internalMessage = "_nb-l";
export var messageInputCard = "_nb-m";
export var messageInputForm = "_nb-o";
export var messageInputFormInternal = "_nb-p";
export var options = "_nb-q";
export var publicMessageCustomer = "_nb-s";
export var publicMessageMerchant = "_nb-r";
export var removeImageButton = "_nb-d";
export var replyButtons = "_nb-t";
export var showSignatureButton = "_nb-u";
export var spinner = "_nb-v";
export var verticalButtonDivider = "_nb-4";
export var visibilitySelector = "_nb-w";
export var warning = "_nb-x";
export var wrappingText = "_nb-z";
export var writingInternalNoteTopBorder = "_nb-10";